/**
 * Almikia Epic EM (TASK-067): Meta report and event dates are America/Mexico_City days. Mexico
 * has no daylight saving time since 2022, so a day is always the fixed UTC-6 offset window.
 */
const MEXICO_OFFSET = "-06:00";

/** ISO instants bounding the inclusive Mexico City days `from` .. `to` (`YYYY-MM-DD`). */
export const mexicoDayBounds = (
  from?: string,
  to?: string,
): { start?: string; end?: string } => ({
  start: from
    ? new Date(`${from}T00:00:00.000${MEXICO_OFFSET}`).toISOString()
    : undefined,
  end: to
    ? new Date(`${to}T23:59:59.999${MEXICO_OFFSET}`).toISOString()
    : undefined,
});
